import { render } from "./IconUpload.vue?vue&type=template&id=926a8bec"
import script from "./IconUpload.vue?vue&type=script&lang=ts"
export * from "./IconUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script